const TOOLTIP_OPEN_MODEL_VALUE_KEY = Symbol("TOOLTIP_OPEN_MODEL_VALUE_KEY");
export {
  TOOLTIP_OPEN_MODEL_VALUE_KEY
};
//# sourceMappingURL=injectionKeys.js.map
